//@ts-expect-error Untyped dependency
import { getLegacyDefaultColorOptions } from '../../../highcharts/options/defaultOptions';
export const DROPOFF_COLOR = '#b05c7d';
export const StandardSankeyColors = getLegacyDefaultColorOptions('StandardSankeyColors').filter(color => color !== DROPOFF_COLOR);